function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Service from '@ember/service';
import { MerchantCatalogConnectFrontend } from '@square/dashboard-protos/models/squareup/connect/v2/catalog/frontend/catalog_connect_frontend';
import rpc from '@square/dashboard-utilities/clients/rpc';

// Use the same version as the search API in ./merchant-catalog-dashboard-fe.ts
const COMBO_ITEMS_API_VERSION = '2051-01-04';

/**
 * This service wraps a catalog-connect-v2 client for the MerchantCatalogConnectFrontend service.
 *
 * A service was necessary to allow us to lock to a version header for endpoints under the service.
 * Allowing for consumption of the endpoints directly without using the ember data store + adaptors.
 *
 * proto: https://prototype.sqprod.co/#/docs/squareup.connect.v2.merchant_catalog.frontend.MerchantCatalogConnectFrontend
 */
export default class MerchantCatalogConnectFe extends Service {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "client", null);
  }
  getClient() {
    if (!this.client) {
      this.client = this._createClient();
    }
    return this.client;
  }
  _createClient() {
    const additionalHeaders = new Map();
    additionalHeaders.set('Square-Version', COMBO_ITEMS_API_VERSION);
    return MerchantCatalogConnectFrontend.create(rpc(undefined, {
      additionalHeaders
    }));
  }
}